import { useContext } from 'react';

import Navigation from 'components/Navigation';
import { NavigationContext } from 'context/navigationContext';
import { MenuItem } from 'types/MenuItem';
import ApartmentView from 'views/ApartmentView';
import FloorsView from 'views/FloorsView';
import GalleryView from 'views/GalleryView';
import MapView from 'views/MapView';
import ThreeDView from 'views/ThreeDView';

const Router = () => {
  const { activeNavigationItem, setActiveNavigationItem } =
    useContext(NavigationContext);

  const handleMenuChange = (newItem: MenuItem) => {
    setActiveNavigationItem(newItem);
  };

  return (
    <>
      <Navigation
        activeItem={activeNavigationItem}
        onChange={handleMenuChange}
      />
      {activeNavigationItem === 0 && <ThreeDView />}
      {activeNavigationItem === 1 && <GalleryView />}
      {activeNavigationItem === 2 && <FloorsView />}
      {activeNavigationItem === 3 && <ApartmentView />}
      {activeNavigationItem === 4 && <MapView />}
    </>
  );
};

export default Router;
